import Vue from 'vue';
import Vuex from 'vuex';
import Equipment from './src/search/Equipment.vue';
import { BlueSearch, store } from '@bluemodus/blue-search';

if (document.readyState === 'loading')
  window.addEventListener('DOMContentLoaded', setup);
else 
  setup();

function setup() {
  const equipment = document.querySelector('#searchEquipment');
  const equipmentOptions = { ...equipment.dataset };

  Vue.config.productionTip = false;

  Vue.use(Vuex);
  Vue.use(BlueSearch, equipmentOptions);

  new Vue({
    store: new Vuex.Store(store),
    render: h => h(Equipment),
  }).$mount(equipment);
}